// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__YkkSh","dark":"dark__2Q-Ib","white":"white__1F90u","header-logo":"header-logo__2dW65","text":"text__2ThK8","header_sub_title":"header_sub_title__3o0uT"};